module.exports = "/images/fr-h.svg?cb7a42b682648b081423c93a676b3791";